import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './i18n';
import './index.scss';
import { MainPage } from './pages/MainPage';
import { Helmet } from 'react-helmet';
import { MainPageV2 } from './pages/LandingPage2/MainPageV2';
import { MainPageV3 } from './pages/LandingPage3/MainPageV3';
import MailVerification from './pages/ConfirmPages/MailVerification';
import ChangePassword from './pages/ConfirmPages/ChangePassword';
import MillPrices from './pages/MillPrices';
import { MobileProvider } from './context/MobileContext';

const { version } = require('../package.json')

console.log(version)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

type Props = {
  setScriptLoaded: any
}

const PageTracking = ({ setScriptLoaded }: Props) => {
  const isLoaded = useRef<boolean>(false)

  useEffect(() => {
    // Create a script element to load the gtag.js script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', process.env.REACT_APP_MEASUREMENT_ID);
    if (process.env.REACT_APP_ENV === "prod") {
      window.gtag('config', 'AW-385834636');
    }
    isLoaded.current = true
    setScriptLoaded(true)
    // eslint-disable-next-line
  }, [])

  return <></>
};

const Rooting = () => {
  const [scriptLoaded, setScriptLoaded] = useState<boolean>(false)

  return (
    <BrowserRouter >
      <PageTracking setScriptLoaded={setScriptLoaded} />
      {
        scriptLoaded &&
        <Routes>
          <Route path="email_verified" element={
            <MailVerification />
          } />
          <Route path="change_password" element={
            <ChangePassword />
          } />
          <Route path="/" element={<Navigate to={'/home'} />} />
          <Route path="/*" element={
            <div style={{ width: "100%", height: "100%" }}>
              <Helmet>
                <title>Pempem</title>
                <meta name="description" content="Nikmati Berniaga Sawit Yang Transparan, Jujur dan Adil Pempem: Beli Lebih Banyak Buah, Dengan Keberlanjutan" />
              </Helmet>
              <MainPage />
            </div>} />

          <Route path="/mills/*" element={
            <div>
              <Helmet>
                <title>Pempem</title>
                <meta name="description" content="Nikmati Berniaga Sawit Yang Transparan, Jujur dan Adil Pempem: Beli Lebih Banyak Buah, Dengan Keberlanjutan" />
              </Helmet>
              <MillPrices />
            </div>} />

          <Route path="/landingpage2" element={<Navigate to={'/landingpage2/landingpage2_ask_transport'} />} />
          <Route path="/landingpage2/*" element={
            <div style={{ width: "100%", height: "100%" }}>
              <Helmet>
                <title>Pempem</title>
                <meta name="description" content="Nikmati Berniaga Sawit Yang Transparan, Jujur dan Adil Pempem: Beli Lebih Banyak Buah, Dengan Keberlanjutan" />
              </Helmet>
              <MainPageV2 />
            </div>} />

          <Route path="/landingpage3/*" element={
            <div id='landingpage3' style={{ width: "100%", height: "100%" }}>
              <Helmet>
                <title>Pempem</title>
                <meta name="description" content="Nikmati Berniaga Sawit Yang Transparan, Jujur dan Adil Pempem: Beli Lebih Banyak Buah, Dengan Keberlanjutan" />
              </Helmet>
              <MainPageV3 />
            </div>} />
        </Routes>
      }
    </BrowserRouter>
  )
}

root.render(
  <React.StrictMode>
    <MobileProvider>
      {/* <TranslationComponent /> */}
      <Rooting />
    </MobileProvider>
  </React.StrictMode>
);